import ClubMemberAccessMediumGantner from '../dto/ClubMemberAccessMediumGantner';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubMemberAccessMediumGantnerRepository {

    static find(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/access-mediums/gantner`)
                .then(response => resolve(response.data.data.map(data => ClubMemberAccessMediumGantner.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(accessMediumId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-member-access-mediums/${accessMediumId}/gantner`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubMemberAccessMediums) {
        return Promise.all(clubMemberAccessMediums.map(clubMemberAccessMedium => {
            const data = {name: clubMemberAccessMedium.name};
            return new Promise((resolve, reject) => {
                axios
                    .put(`/club/club-member-access-mediums/${clubMemberAccessMedium.id}/gantner`, data)
                    .then(() => resolve())
                    .catch(error => reject(Error.fromResponse(error.response)));
            });
        }));
    }

}
